import { IUser } from "../interfaces/user";
import { get } from "../util/api";

export const fetchUser = async (token: string): Promise<IUser> => {
  const url = `${process.env.HOST_ENV}/user/v1/user/sdk/getUser`;
  try {
    const res = await get<{ success: boolean; data: { user: IUser } }>(
      url,
      token
    );
    const body = res.parsedBody;
    if (!res || !body || !body.success || !body.data)
      throw new Error("Error Fetching User");

    if (body.data.user) return body.data.user;
    else throw new Error("User Not Found");
  } catch (e) {
    console.log(e);
    throw new Error("Error Fetching User");
  }
};
